const others = {
  param: 'Parâmetros',
  message: 'Sempre que tivermos alguma novidade, te manteremos informado(a) por aqui!',
  matchTrue: 'Selecione uma das opções ao lado para iniciar',
  matchFalse: 'Selecione uma das opções abaixo para iniciar',
  infoLabel: 'Últimos avisos',
  infoMsg: 'sem avisos no momento'
}

export default others;
